import { create } from 'zustand';
import { User as ApiUser } from 'src/types/api/UserList';

interface UsersState {
  isAddUserModalOpen: boolean;
  filterValue: string;
  currentUser: ApiUser | null;
  
  // Actions
  setIsAddUserModalOpen: (open: boolean) => void;
  setFilterValue: (value: string) => void;
  setCurrentUser: (user: ApiUser | null) => void;
  
  // Reset all selections
  resetSelections: () => void;
}

export const useUsersStore = create<UsersState>((set) => ({
  isAddUserModalOpen: false,
  filterValue: '',
  currentUser: null,
  
  setIsAddUserModalOpen: (open) => set({ isAddUserModalOpen: open }),
  setFilterValue: (value) => set({ filterValue: value }),
  setCurrentUser: (user) => set({ currentUser: user }),
  
  resetSelections: () => set({ currentUser: null }),
}));
